import type { BloodGlucoseClassification } from "@/model/BloodGlucoseClassification"
import cn from "@/util/cn"
import {
  readingValueBackgroundColorFor,
  readingValueTextColorFor,
} from "../dashboardData"

type MeasurementCellProps = {
  value?: number
  classification?: BloodGlucoseClassification
  onClick?: () => void
}

const MeasurementCell = ({ value, classification, onClick }: MeasurementCellProps) => {
  const style = {
    backgroundColor: readingValueBackgroundColorFor(classification),
    color: readingValueTextColorFor(classification),
  }

  if (value == null || !classification) {
    return (
      <span
        className={cn(
          "flex h-11 items-center justify-center rounded-[10px] text-center text-[23px] font-semibold",
        )}
        style={style}
      >
        -
      </span>
    )
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick}
      className={cn(
        "flex h-11 w-full items-center justify-center rounded-[10px] text-center text-[23px] font-semibold",
      )}
      style={style}
    >
      {value}
    </button>
  )
}

export default MeasurementCell
